import mockAPI from './test-api/team-purchases.api'
import realAPI from './real-api/team-purchases.api'

const api = process.env.NODE_ENV === 'test' ? mockAPI : realAPI

export default{
  api
}



// WEBPACK FOOTER //
// ./src/api/team-purchases.api.js